<template>
  <div>
    <v-alert v-if="error" type="error" class="ma-8">
      {{ error }}
    </v-alert>
    <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
    <v-data-table
      v-if="!loading"
      class="ma-4 table"
      disable-pagination
      disable-filtering
      disable-sort
      dense
      :headers="headers"
      :items="items"
      :hide-default-footer="true"
    >
    </v-data-table>
  </div>
</template>

<script>
import EquivalenceConfigurationService from '@/services/insurancepricing/EquivalenceConfigurationService';

const service = new EquivalenceConfigurationService();

export default {
  props: {
    equivConf: Object,
  },

  data() {
    return {
      headers: [
        {text: 'Plano', align: 'start', value: 'plan', sortable: false},
        {text: 'Operadora', align: 'start', value: 'carrier', sortable: false},
        {
          text: 'Rede de Prestadores',
          align: 'end',
          value: 'providers',
          sortable: false,
        },
      ],
      items: [],
      loading: true,
      error: null,
    };
  },

  async mounted() {
    try {
      this.loading = true;
      let result = await service.findProviders(this.equivConf.id);
      this.items = result.data
        .filter((i) => (i.type == 'hospital'))
        .map((item) => {
          return {
            plan: `${item.planProductCode}-${item.planDescription}`,
            carrier: item.planCarrierName,
            providers: item.networkProviders.join(','),
          };
        });
    } catch (e) {
      this.error = e;
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.table {
  border: 1px solid var(--v-border-base);
}
</style>